var noCase = require('no-case')

/**
 * Path case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return noCase(value, locale, '/')
}



//////////////////
// WEBPACK FOOTER
// ./~/path-case/path-case.js
// module id = 2007
// module chunks = 0